import { createStyles } from "@material-ui/core";

export const TwoFactorAuthDialogStyles = (theme: any) =>
  createStyles({
    inputContainer: {
      marginTop: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    input: {
      width: "100%",
    },
    errorText: {
      color: "red",
      fontSize: "14px",
      marginTop: "4px",
    },
  });
